import styled from 'styled-components';  
import Img1 from '../../../img/vol1.jpeg';
const Main =styled.div`
    margin-top: 50px;
    width: 100%;

`

const Vol1: React.VFC = () => {
  return (
    <Main>
<div className="text-break Blog-comment">
                <p>こんにちは！STEMON秦校です。</p>
                <p>今週のレッスンテーマは『色』。</p>
                <p>人間の目がどのようにして色を認識するかについて学習しました。例えば、緑色に見える草は、光のうち緑色のものだけを反射するため、その光が目に届くことで緑色に見える、といった感じです。</p>
                <p>小学１年生には少し難しいかなと思いながら説明しましたが、みんなすぐに理解してくれたようで、「じゃあ、あの黄色い壁は、黄色の光だけを反射しゆうがや！」と、教室にあるものの色を探しては発言してくれていました。
                </p>
                <p>その後は、色相環を取り付けたルーレットの制作タイム。「ぼくはルーレットをいっぱいつくる！」「わたしは大きいルーレットにする！」と、思い思いのルーレットをつくってくれました。</p>
                <div className="card-mokuji">
                    <img width="335" height="251" src={Img1} alt="" />
                </div>
                <p>途中、「ルーレットがうまく回らない」と困っていた生徒に、「回す部分からの力が上手く伝わってないのかもね」とヒントを出すと、「じゃあ、ここにこの輪っかをつけて締めてみる！」と、見事に成功！１つ目のヒントは敢えて不親切なものにしているのですが、２つ目以降のヒントは要らなかったようです(;^_^A
                </p>
                <p>次に、そのルーレットを使ったゲームを考案してもらい、最後にプレゼンタイム。自分のつくったルーレットのコンセプトをみんなの前で発表してくれました。</p>
                <p>20～30分という限られた時間の中で、ゼロから作品を創り出す子どもたちの能力に、毎回驚かされます。</p>
                <p>STEMON秦校でのレッスンはまだ始まったばかり。これからたくさんの驚きや感動を子どもたちと一緒に体験できることを楽しみにしています。</p>
            </div>
    </Main>
    
  );
}
export default Vol1;